import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/viadeo-square': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M400 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H400C426.5 480 448 458.5 448 432V80C448 53.5 426.5 32 400 32zM280.7 381.2C238.3 427.4 160.7 427.8 118.3 381.2 50.3 307.6 98.5 185.1 199.5 185.1 212.8 185.1 226.1 187.2 238.6 191.8 234.3 200.2 231.3 209.4 230.2 218.9 220.5 214.8 210 212.9 199.5 212.9 150.7 212.9 114.9 254.6 114.9 301.8 114.9 344.8 143.4 380.5 184.4 387.7 245.9 363.7 257.3 270.1 257.3 212.7 257.3 205.4 257.3 197.9 256.7 190.6 245.5 157.7 230.1 126 212.5 96.1 239.6 114.4 254.4 158.6 256.7 190.2V190.6C264.4 213.1 268.5 236.8 268.5 260.6 268.5 314.7 246.6 359.6 200.2 388.8L197.8 389C247.8 390 284 350.4 284 301.8 284 289.6 281.9 277.5 277.1 266.1 286.6 264.2 295.6 260.5 303.5 255.6 318.8 292.2 316.1 342.9 280.7 381.2zM309 233.7C295.7 233.7 283.9 226.6 274.6 217.6 296.5 205.6 324.2 186.9 336.9 164.6 338.4 161.6 341 156 341.4 152.6 328.9 180.5 297.2 202.4 267.5 209.3 262.8 202 260 193.8 260 185 260 174.7 265.2 160.9 272.9 153.4 294.5 132.9 325.9 144.9 345.3 103.4 377.8 149.6 358.4 233.7 309 233.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/viadeo-square.js
// module id = 2TW7
// module chunks = 144